import _objectWithoutProperties from "/vercel/workpath0/.yarn/cache/@babel-runtime-npm-7.12.5-b3edb8ee8e-423fb00793.zip/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import React from 'react';
import styled from 'styled-components';
import { Relative } from './Position';
import Avatar from './Avatar';
import theme from './theme';
var ChildAvatar = styled(Avatar).withConfig({
  displayName: "AvatarPair__ChildAvatar",
  componentId: "sc-1v5x8y5-0"
})(["position:absolute;right:-15%;bottom:-9%;box-shadow:0 0 0 2px rgba(255,255,255,0.8);"]);

var AvatarPair = function AvatarPair(_ref) {
  var children = _ref.children,
      rest = _objectWithoutProperties(_ref, ["children"]);

  var avatars = React.Children.map(children, function (child, i) {
    return i === 0 ? React.cloneElement(child, {
      size: 40
    }) : /*#__PURE__*/React.createElement(ChildAvatar, _extends({
      bg: "white"
    }, child.props, {
      size: 20
    }));
  });
  return /*#__PURE__*/React.createElement(Relative, _extends({
    display: "inline-flex"
  }, rest), avatars);
};

AvatarPair.displayName = "AvatarPair"; // styled() changes this

AvatarPair.displayName = 'AvatarPair';
AvatarPair.defaultProps = {
  theme: theme
};
export default AvatarPair;